// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isExists/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isExists = convertToFP(fn, 3);
export default isExists;